// extracted by mini-css-extract-plugin
export default {"cookie-banner":"CookieBanner_cookie-banner__Ejh3K","cookie-banner-content":"CookieBanner_cookie-banner-content__3szJz","cookie-banner-btn":"CookieBanner_cookie-banner-btn__mPx+q"};